export const KIOSK_ACTIVATION_KEY = 'kiosk_activation'
export const KIOSK_SESSION_KEY = 'kiosk_session'
export const KIOSK_TOKEN_KEY = 'kiosk_token'
export const KIOSK_BROWSER_ID_KEY = 'kiosk_browser_id'
